import { render, staticRenderFns } from "./peaFinancialAssets.vue?vue&type=template&id=0e15ea66&scoped=true"
import script from "./peaFinancialAssets.vue?vue&type=script&lang=js"
export * from "./peaFinancialAssets.vue?vue&type=script&lang=js"
import style0 from "./peaFinancialAssets.vue?vue&type=style&index=0&id=0e15ea66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15ea66",
  null
  
)

export default component.exports